import { render, staticRenderFns } from "./disposed.vue?vue&type=template&id=79b3d8cc&"
import script from "./disposed.vue?vue&type=script&lang=js&"
export * from "./disposed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports